import palette from './palette';
import { TypographyPropsVariantOverrides } from '@mui/material/Typography';

declare module '@mui/material/Typography' {
  interface TypographyPropsVariantOverrides {
    'text-lg': true;
    'text-lg-sb': true;
    'text-md': true;
    'text-md-sb': true;
    'text-sm': true;
    'text-sm-sb': true;
    'button-lg': true;
    'button-sm': true;
    cellTextOverflow: true;
  }
}

export default {
  useNextVariants: true,
  fontFamily: ['Open Sans', 'Manrope', 'Coolvetica', 'sans-serif'].join(','),
  h1: {
    fontSize: '1.875rem',
    lineHeight: '2.25rem',
    fontWeight: 400,
  },
  h2: {
    fontSize: '1.5rem',
    lineHeight: '1.8125rem',
    fontWeight: 400,
  },
  h3: {
    fontSize: '1rem',
    lineHeight: '1.1875rem',
    fontWeight: 400,
  },
  h4: {
    fontSize: '0.875rem',
    lineHeight: '1.05rem',
    fontWeight: 400,
  },
  'text-lg-sb': {
    fontSize: '1rem',
    lineHeight: '1.375rem',
    fontWeight: 600,
  },
  'text-lg': {
    fontSize: '1rem',
    lineHeight: '1.375rem',
    fontWeight: 400,
  },
  'text-md': {
    fontSize: '0.875rem',
    lineHeight: '1.25rem',
    fontWeight: 400,
  },
  'text-md-sb': {
    fontSize: '0.875rem',
    lineHeight: '1.25rem',
    fontWeight: 600,
  },
  'text-sm': {
    fontSize: '0.75rem',
    lineHeight: '1rem',
    fontWeight: 400,
  },
  'text-sm-sb': {
    fontSize: '0.75rem',
    lineHeight: '1rem',
    fontWeight: 600,
  },
  'button-lg': {
    fontSize: '0.875rem',
    lineHeight: '1rem',
    fontWeight: 700,
    textTransform: 'uppercase',
    letterSpacing: '0.2px',
  },
  'button-sm': {
    fontSize: '0.75rem',
    lineHeight: '0.75rem',
    fontWeight: 700,
    textTransform: 'uppercase',
    letterSpacing: '0.2px',
  },
  body1: {
    fontSize: '0.875rem',
  },
  body2: {
    fontSize: '0.625rem',
  },
  overline: {
    color: palette.primary.light,
    fontSize: 12,
    fontWeight: 'bold',
    letterSpacing: 0.4,
  },
  cellTextOverflow: {
    maxWidth: 200,
    '& .MuiTypography-root': {
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis',
      overflow: 'hidden',
      maxWidth: 'inherit',
    },
  },
};
